const arraysIntersect = <T>( array1: T[], array2: T[]): T[] => {
    return array1.filter((element: T) => {
        return array2.includes(element)
    })
}

export default arraysIntersect